export default "__VITE_ASSET__CNB4ZG5V__"